import dayjs from 'dayjs'

import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isYesterday from 'dayjs/plugin/isYesterday'
import isToday from 'dayjs/plugin/isToday'
import localeData from 'dayjs/plugin/localeData'

import 'dayjs/locale/en'
import 'dayjs/locale/ja'
import 'dayjs/locale/th'
import 'dayjs/locale/id'

dayjs.extend(localeData)
dayjs.extend(updateLocale)
dayjs.extend(isYesterday)
dayjs.extend(isToday)
dayjs.extend(localizedFormat)

dayjs.extend(relativeTime, {
  thresholds: [
    { l: 's', r: 59 },
    { l: 'ss', r: 59, d: 'second' },
    { l: 'm', r: 1 },
    { l: 'mm', r: 59, d: 'minute' },
    { l: 'h', r: 1 },
    { l: 'hh', r: 24, d: 'hour' },
  ],
})

dayjs.updateLocale('en', {
  weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
    '_'
  ),
  months:
    'January_February_March_April_May_June_July_August_September_October_November_December'.split(
      '_'
    ),
  weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
  monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
  weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
  relativeTime: {
    future: 'in %s',
    past: '%s',
    s: '1 sec',
    ss: '%d sec',
    m: '1 min',
    mm: '%d min',
    h: '1 h',
    hh: '%d h',
  },
})

dayjs.updateLocale('ja', {
  relativeTime: {
    future: '%s秒後',
    past: '%s',
    s: '1秒前',
    ss: '%d秒前',
    m: '1分前',
    mm: '%d分前',
    h: '1時間前',
    hh: '%d時間前',
  },
})

dayjs.updateLocale('th', {
  relativeTime: {
    future: '%s',
    past: '%s',
    s: '1 วินาที',
    ss: '%d วินาที',
    m: '1 นาที',
    mm: '%d นาที',
    h: '1 ชม',
    hh: '%d ชม',
  },
})

dayjs.updateLocale('id', {
  relativeTime: {
    future: '%s',
    past: '%s',
    s: '1 mnt',
    ss: '%d mnt',
    m: '1 mnt',
    mm: '%d mnt',
    h: '1 j',
    hh: '%d j',
  },
})
